/**
 * "1" + "tablet" -> "1 tablet". Records stored before the backend split
 * amounts on reading can carry the unit twice ("1 tablet" + "tablet"); the
 * unit is then not repeated ("1 tablet", never "1 tablet tablet").
 */
function unitWord(unit: string): string {
  const word = unit.trim().toLowerCase().replace(/\s+/g, " ").replace(/\(s\)$/, "");
  return word.length > 2 && word.endsWith("s") ? word.slice(0, -1) : word;
}

export function formatDose(quantity: unknown, unit: unknown): string {
  const amount = quantity == null ? "" : String(quantity).trim();
  const u = typeof unit === "string" ? unit.trim() : "";
  if (!amount || !u) return amount || u;
  const written = amount.match(/^\d+(?:\.\d+)?(?:\s*\/\s*\d+)?\s*([A-Za-z][A-Za-z ()]*?)\s*$/);
  if (written && unitWord(written[1]) === unitWord(u)) return amount;
  return `${amount} ${u}`;
}
